import { render, staticRenderFns } from "./LoginImpersonateUser.vue?vue&type=template&id=52fd39c8&"
import script from "./LoginImpersonateUser.vue?vue&type=script&lang=js&"
export * from "./LoginImpersonateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports